import {
  createRouter,
  createWebHistory
} from 'vue-router'; // Correct import for Vue 3
import HomeView from '../views/HomeView.vue';
import ContactUs from '../views/ContactUs.vue';
import AboutUs from '../views/AboutUs.vue';
import Subscribe from '../views/Subscribe.vue';
import AIMatching from '../views/AIMatching.vue';
import HousingAssistance from '../views/HousingAssistance.vue';
import Relocation from '../views/Relocation.vue';
import Explore from '../views/Explore.vue';
import Teach from '../views/Teach.vue';
import Community from '../views/Community.vue';
import FinancialResources from '../views/FinancialResources.vue';
import Transportation from '../views/Transportation.vue';
import Essentials from '../views/Essentials.vue';
import TeacherResources from '../views/TeacherResources.vue';
import ClassroomManagement from '../views/ClassroomManagement.vue';
import OnlineCourses from '../views/OnlineCourses.vue';
import Disclaimer from '../views/Disclaimer.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';
import AssessmentDataTracking from '../views/AssessmentDataTracking.vue';
import LessonPlanningResources from '../views/LessonPlanningResources.vue';
import TechIntegration from '../views/TechIntegration.vue';
import SocialLearningResources from '../views/SocialLearningResources.vue';
import StudyInUS from '../views/StudyInUS.vue';

const routes = [{
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: ContactUs,
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: AboutUs,
  },
  {
    path: '/explore',
    name: 'explore',
    component: Explore,
  },
  {
    path: '/teach',
    name: 'teach',
    component: Teach,
  },
  {
    path: '/community',
    name: 'community',
    component: Community,
  },
  {
    path: '/financial-resources',
    name: 'financial-resources',
    component: FinancialResources,
  },
  {
    path: '/ai-matching',
    name: 'ai-matching',
    component: AIMatching,
  },
  {
    path: '/housing-resources',
    name: 'housing-resources',
    component: HousingAssistance,
  },
  {
    path: '/relocation-support',
    name: 'relocation-support',
    component: Relocation,
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: Subscribe,
  },
  {
    path: '/transportation',
    name: 'transportation',
    component: Transportation,
  },
  {
    path: '/essentials',
    name: 'essentials',
    component: Essentials,
  },
  {
    path: '/teacher-resources',
    name: 'teacher-resources',
    component: TeacherResources,
  },
  {
    path: '/classroom-management',
    name: 'classroom-management',
    component: ClassroomManagement,
  },
  {
    path: '/online-courses',
    name: 'online-courses',
    component: OnlineCourses,
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: Disclaimer,
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy,
  },
  {
    path: '/assessment-and-data-tracking',
    name: 'assessment-and-data-tracking',
    component: AssessmentDataTracking,
  },
  {
    path: '/lesson-planning-and-curriculum-resources',
    name: 'lesson-planning-and-curriculum-resources',
    component: LessonPlanningResources,
  },
  {
    path: '/tech-integration',
    name: 'tech-integration',
    component: TechIntegration,
  },
  {
    path: '/social-learning-resources',
    name: 'social-learning-resources',
    component: SocialLearningResources,
  },
  {
    path: '/study-in-us',
    name: 'study-in-us',
    component: StudyInUS,
  },
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // Correct history mode for Vue 3
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      left: 0,
      behavior: "smooth"
    }; // Smooth scroll to top
  }
});



export default router; // Export the router instance